<template>
  <!-- 固定资产投资 -->
<div class="OurService" style="align-self: center;">
<!-- 黑头 -->
 <div class="header flex-all-center">
    <p>{{ $t("ourServiceFixed.title")}}</p>
  </div>

  <div class="main">
    <div class="maincontent">
      <!-- 土地开发 -->
      <div class = "mt-80 flex-all-center title-1" > 
        <p>{{ $t("ourServiceFixed.text1")}}</p>
      </div>
      <div class="textlayout mt-80">
          <div class="text">
              <p class="flex-all-center title-2">{{ $t("ourServiceFixed.text2")}}</p>

              <p class="textcontent-en" v-if="isEn">{{ $t("ourServiceFixed.text3")}}</p>
              <p class="textcontent-cn" v-else>{{ $t("ourServiceFixed.text4")}}</p>

                <div class="flex-row list-item-content " v-if="isEn">
                  <div class="list-item-en">{{ $t("ourServiceFixed.text5")}}</div>
                  <div class="list-item-en">{{ $t("ourServiceFixed.text6")}}</div>
                  <div class="list-item-en" >{{ $t("ourServiceFixed.text7")}}</div>
                  <div class="list-item-en" >{{ $t("ourServiceFixed.text8")}}</div>
                </div>

                <div class="flex-row list-item-content " v-else>
                  <div class="list-item-cn" >{{ $t("ourServiceFixed.text5")}}</div>
                  <div class="list-item-cn">{{ $t("ourServiceFixed.text6")}}</div>
                  <div class="list-item-cn" >{{ $t("ourServiceFixed.text7")}}</div>
                  <div class="list-item-cn" >{{ $t("ourServiceFixed.text8")}}</div>
                </div>

          </div>
          <img class="img1" src="../../assets/images/OurServiceFixed_pic1.png">
      </div>
      <!-- 酒店投资 -->
      <div class="mt-80 flex-all-center title-1"> 
        <p>{{ $t("ourServiceFixed.text9")}}</p>
      </div>
      <div class="textlayout mt-80">
        <img class="img2" src="../../assets/images/OurServiceFixed_pic2.png">
        <div class="text">
          <p class="flex-all-center title-2">{{ $t("ourServiceFixed.text10")}}</p>

          <p class="textcontent-en" v-if="isEn">{{ $t("ourServiceFixed.text11")}}</p>
          <p class="textcontent-cn" v-else>{{ $t("ourServiceFixed.text11")}}</p>


            <!-- 分割线 -->
             <div class="flex-all-center">
                <div class="separator"></div>
             </div>
          <p class="flex-all-center title-2">{{ $t("ourServiceFixed.text12")}}</p>

          <p class="textcontent-en" v-if="isEn">{{ $t("ourServiceFixed.text13")}}</p>
          <p class="textcontent-cn" v-else>{{ $t("ourServiceFixed.text13")}}</p>

            <!-- 分割线 -->
             <div class="flex-all-center">
                <div class="separator"></div>
             </div>
          <p class="flex-all-center title-2">{{ $t("ourServiceFixed.text14")}}</p>

          <p class="textcontent-en" v-if="isEn">{{ $t("ourServiceFixed.text15")}}</p>
          <p class="textcontent-cn" v-else>{{ $t("ourServiceFixed.text15")}}</p>

            <!-- 分割线 -->
             <div class="flex-all-center">
                <div class="separator"></div>
             </div>
          <p class="flex-all-center title-2">{{ $t("ourServiceFixed.text16")}}</p>

          <p class="textcontent-en" v-if="isEn">{{ $t("ourServiceFixed.text17")}}</p>
          <p class="textcontent-cn" v-else>{{ $t("ourServiceFixed.text17")}}</p>

        </div>

      </div>
    </div>
  </div>
  <div class="footer"></div>

</div>
</template>

<script>
import { mapState } from "vuex";


export default {
  name: "OurServiceFixed",
  computed: {
    ...mapState({
      isEn: (state) => state.isEn,
    }),
  },
  data() {
    return {
    };
  },
  created() {

  },
  beforeDestroy()
  {

  },
  methods: {

  },
};
</script>

<style lang="scss" scoped>
.OurService{
  color: #000;
  width: 100%;
  .header{
      height: 400px;
      background: #000;
      font-family: "OPPO-L";
      font-size: 42px;
      color: #fff;
      p{
        text-align: center;
      }
  }
  .main{
    display: flex;
    justify-content: center;
    .maincontent{
      max-width: 1200px;
      color: #606266;
      font-family: "OPPO-R";
      font-size: 17px;
      line-height: 27px;
      margin-top: 17px;
      width: 100%;

      .textlayout{
        display: flex;
        align-items: center;
        justify-content: center;
      }

      p{
        margin-top: 17px;
      }

      .title-1{
        color: #000;
        font-family: "OPPO-B";
        font-size: 40px;
      }

      .title-2{
        font-family: "OPPO-B";
        font-size: 22px;
        color: #000;
      }

      .text{
        width: 544px;
      }

      .textcontent-cn{
        text-indent: 34px;
        text-align:justify;
      }

      .textcontent-en{
        text-indent: 34px;
        text-align: justify;
      }

      .list-item-content{
        gap: 1px;
        width: 100%;
      }

      .list-item-cn {
        border: 2px solid #000;
        padding-top: 14px;
        padding-right: 12px;
        padding-bottom: 11px;
        padding-left: 12px;
        font-family: "OPPO-B";
        font-size: 16px;
        color: #000;
        margin-top: 23px;
        height:60px;
        width: 100%;
        text-align: center;
      }

      .list-item-en {
        border: 2px solid #000;
        padding-top: 14px;
        padding-right: 12px;
        padding-bottom: 11px;
        padding-left: 12px;
        font-family: "OPPO-B";
        font-size: 16px;
        color: #000;
        margin-top: 23px;
        width: 100%;
        height:90px;
        text-align: center;
      }

      .img1{
      margin-top: 0px;
      width: 600px;
      height: auto;
      margin-left: 100px;
      }

      .img2{
      width: 600px;
      height: auto;
      margin-right: 100px;
      }

      .separator {
        height: 1.5px;
        background-color: #000;
        margin: 20px 97px;
        width: 350px;
      }

    }
  }
  .footer{
    margin-top: 120px;
  }
}







@media (max-width: 768px) {
.OurService{
  color: #000;
  width: 100%;
  .header{
      height: 400px;
      background: #000;
      font-family: "OPPO-L";
      font-size: 42px;
      color: #fff;
      p{
        text-align: center;
      }
  }
  .main{
    display: flex;
    justify-content: center;

    .maincontent{

      color: #606266;
      font-family: "OPPO-R";
      font-size: 17px;
      line-height: 27px;
      margin-top: 0px;
      width: 90%;

      .textlayout{
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
      }

      p{
        margin-top: 17px;
      }

      .title-1{
        text-align: center;
        color: #000;
        font-family: "OPPO-B";
        font-size: 40px;
        line-height: 40px;
      }

      .title-2{
        text-align: center;
        font-family: "OPPO-B";
        font-size: 22px;
        color: #000;
      }

      .text{
        width: 100%;
      }

      .textcontent-cn{
        text-indent: 34px;
        text-align:justify;
      }

      .textcontent-en{
        text-indent: 34px;
        text-align: justify;
      }

      .list-item-content{
        gap: 1px;
        width: 100%;
        justify-content: space-between;
      }

      .list-item-cn {
        border: 2px solid #000;
        padding-top: 14px;
        padding-right: 12px;
        padding-bottom: 11px;
        padding-left: 12px;
        font-family: "OPPO-B";
        font-size: 12px;
        color: #000;
        margin-top: 23px;
        height:60px;
        width: 100%;
        text-align: center;
      }

      .list-item-en {
        border: 2px solid #000;
        padding-top: 14px;
        padding-right: 0px;
        padding-bottom: 11px;
        padding-left: 0px;
        font-family: "OPPO-B";
        font-size: 14px;
        color: #000;
        margin-top: 23px;
        width: 100%;
        height:90px;
        text-align: center;
      }

      .img1{
      margin-top: 40px;
      width: 90%;
      height: auto;
      margin-left: 0px;
      }

      .img2{
      width: 90%;
      height: auto;
      margin-right: 0px;
      }

      .separator {
        height: 1.5px;
        background-color: #000;
        margin: 20px 97px;
        width: 350px;
      }

    }
  }
  .footer{
    margin-top: 40px;
  }
}


}

</style>
